export const basicFormData = () => ({
  inputData: {
    item_code: "",
    description: "",
    uom_id: "",
    cost: "0",
    type: null,
    origin: null,
    category_id: null,
    created_by: null,
    updated_by: null,
    is_active: true,
  },
});

export const createPageData = () => {
  const payload = {
    modelName: "item_masters",
  };

  const navigatePage = { back: "/item-list" };

  const headerName = "Item";

  const validationType = "ItemCreate";
  const createEndpoint = "/createItem";
  const updateEndpoint = "/updateItem";
  const getEndpoint = "/getItemById";
  const dependentDropdownData = [
    {
      module_name: "uom_masters",
      initialPayload: {
        modelName: "uom_masters",
        whereCondition: {
          is_active: true,
        },
      },
      isOtherDependentOnThis: false,
      patchFieldName: "uom_name",
      dropdownDataValue: "uom_id",
      endPoint: "/listUom",
    },
  ];
  const originData = [
    {
      options: [
        { label: "Bermad", value: "1" },
        { label: "Local", value: "2" },
      ],
    },
  ];
  const itemType = [
    {
      options: [
        { label: "Make", value: "1" },
        { label: "Buy", value: "2" },
      ],
    },
  ];
  const categoryPayload = {
    modelName: "category_masters",
    whereCondition: {
      is_active: true,
    },
  };
  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
    dependentDropdownData,
    originData,
    itemType,
    categoryPayload,
  };
};

export const listPageData = (id) => {
  const payload = {
    modelName: "item_masters",

    whereCondition: {
      type: id,
    },

    relations: [
      {
        module: "uom_masters",
        moduleAs: "uom",
      },
      {
        module: "category_masters",
        moduleAs: "category",
      },
      {
        module: "user_masters",
        moduleAs: "createdBy",
      },
      {
        module: "user_masters",
        moduleAs: "updatedBy",
      },
    ],
  };

  const columnData = [
    { label: "sr.no", value: "index" },
    { label: "Item Code", value: "item_code" },
    { label: "Description", value: "description" },
    { label: "UOM", value: "uom.uom_name" },
    { label: "Cost", value: "cost" },
    { label: "Type", value: "type" },
    { label: "Origin", value: "origin" },
    { label: "Category", value: "category.category_name" },
    { label: "Created By", value: "createdBy.first_name" },
    { label: "Status", value: "is_active" },
    { label: "Action", value: "actions" },
  ];

  const navigatePage = {
    create: "/item-create",
    edit: "/item-create",
    view: "/item-view",
  };

  const searchfields = [
    "item_code",
    "cost",
    "uom.uom_name",
    "category.category_name",
    "createdBy.first_name",
    "createdBy.last_name",
    "updatedBy.first_name",
    "updatedBy.last_name",
  ];

  const headerName = "Item";
  const endpoint = "/listItem";
  const exportFileName = "itemData.xlsx";

  return {
    payload,
    navigatePage,
    headerName,
    columnData,
    endpoint,
    searchfields,
    exportFileName,
  };
};
export const exportPageData = {
  modelName: "item_masters",
  relations: [
    {
      module: "uom_masters",
      moduleAs: "uom",
    },
    {
      module: "category_masters",
      moduleAs: "category",
    },
    {
      module: "user_masters",
      moduleAs: "createdBy",
    },
    {
      module: "user_masters",
      moduleAs: "updatedBy",
    },
  ],
  pagination: { page: 1, pageSize: 10000 },
};
